// import { useState, useEffect } from "react";
// import {
//   Grid,
//   CardContent,
//   Typography,
//   TextField,
//   Button,
//   Box,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Divider,
//   Skeleton,
//   Paper,
//   Avatar,
// } from "@mui/material";
// import { createTheme, ThemeProvider } from "@mui/material/styles";
// import { Save } from "@mui/icons-material";

// import apiClient from "../../context/apiClient";
// import Layout from "../common/Layout";

// // --- Color Palette ---
// const primaryPurple = "#4F46BA";
// const lightBackground = "#F1FFFA";
// const accentBeige = "#cececebe";
// const textBlack = "#000000";
// const gray = "#A9A5A5";
// const label = "#615f5f88";

// // --- MUI Theme Customization ---
// const theme = createTheme({
//   typography: {
//     fontFamily: "Roboto, sans-serif",
//   },
//   components: {
//     MuiTextField: {
//       styleOverrides: {
//         root: {
//           "& .MuiOutlinedInput-root": {
//             backgroundColor: lightBackground,
//             borderRadius: "8px",
//             fontSize: "14px",
//             "& .MuiOutlinedInput-notchedOutline": {
//               border: `1px solid ${label}`,
//             },
//             "&:hover .MuiOutlinedInput-notchedOutline": {
//               borderColor: label,
//             },
//             "&:hover": {
//               backgroundColor: accentBeige,
//             },
//             "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//               borderColor: primaryPurple,
//               borderWidth: "1px",
//             },
//           },
//           "& .MuiInputBase-input": {
//             color: textBlack,
//           },
//           "& .MuiInputLabel-root": {
//             color: gray,
//             "&.Mui-focused, &.MuiFormLabel-filled": {
//               color: label,
//             },
//           },
//         },
//       },
//     },
//     MuiSelect: {
//       styleOverrides: {
//         root: {
//           backgroundColor: lightBackground,
//           borderRadius: "8px",
//           fontSize: "14px",
//           "& .MuiOutlinedInput-notchedOutline": {
//             border: `1px solid ${label}`,
//           },
//           "&:hover .MuiOutlinedInput-notchedOutline": {
//             borderColor: label,
//           },
//           "&:hover": {
//             backgroundColor: accentBeige,
//           },
//           "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//             borderColor: primaryPurple,
//             borderWidth: "1px",
//           },
//         },
//       },
//     },
//     MuiInputLabel: {
//       styleOverrides: {
//         root: {
//           color: gray,
//           "&.Mui-focused": {
//             color: label,
//           },
//         },
//       },
//     },
//     MuiButton: {
//       styleOverrides: {
//         contained: {
//           backgroundColor: primaryPurple,
//           "&:hover": {
//             backgroundColor: "#3A348A",
//           },
//         },
//       },
//     },
//   },
// });

// const showNotification = (message, severity) => {
//   console.log(`[${severity.toUpperCase()}] Notification: ${message}`);
// };

// const industryOptions = [
//   { value: "IT_SOFTWARE", label: "IT & Software" },
//   { value: "FINANCE", label: "Finance & Banking" },
//   { value: "HEALTHCARE", label: "Healthcare" },
//   { value: "ECOMMERCE", label: "E-commerce & Retail" },
//   { value: "EDUCATION", label: "Education" },
//   { value: "MANUFACTURING", label: "Manufacturing" },
//   { value: "OTHER", label: "Other" },
// ];

// const sizeOptions = [
//   { value: "1-10", label: "Startup (1-10)" },
//   { value: "11-50", label: "Small (11-50)" },
//   { value: "51-200", label: "Medium (51-200)" },
//   { value: "201-500", label: "Large (201-500)" },
//   { value: "501-1000", label: "Enterprise (501-1000)" },
//   { value: "1001-5000", label: "Tier 2 (1001-5000)" },
//   { value: "5000+", label: "Global (5000+)" },
// ];

// // --- Refined Skeleton Component ---
// const FormSkeleton = () => (
//   <Box>
//     {/* Section 1: Company Details Skeleton */}
//     <Typography
//       variant="h6"
//       component="h1"
//       gutterBottom
//       sx={{ fontWeight: "bold" }}
//     >
//       <Skeleton width="35%" />
//     </Typography>
//     <Divider sx={{ my: 2, bgcolor: primaryPurple, mb: 3 }} />
//     <Grid container spacing={3} alignItems="center">
//       <Grid item xs={12} md={8}>
//         <Grid container spacing={2}>
//           {[...Array(6)].map((_, i) => (
//             <Grid item xs={12} sm={4} key={i}>
//               <Skeleton
//                 variant="rectangular"
//                 height={56}
//                 sx={{ borderRadius: "8px" }}
//               />
//             </Grid>
//           ))}
//         </Grid>
//       </Grid>
//       <Grid
//         item
//         xs={12}
//         md={4}
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "center",
//           alignItems: "center",
//           gap: 2,
//         }}
//       >
//         <Skeleton variant="circular" width={100} height={100} />
//         <Skeleton
//           variant="rectangular"
//           width={120}
//           height={36}
//           sx={{ borderRadius: "4px" }}
//         />
//       </Grid>
//     </Grid>

//     {/* Section 2: Company Description Skeleton */}
//     <Box sx={{ my: 3 }}>
//       <Typography
//         variant="h6"
//         component="h1"
//         gutterBottom
//         sx={{ fontWeight: "bold" }}
//       >
//         <Skeleton width="45%" />
//       </Typography>
//       <Divider sx={{ my: 2, bgcolor: primaryPurple, mb: 3 }} />
//       <Skeleton
//         variant="rectangular"
//         height={118}
//         sx={{ borderRadius: "8px" }}
//       />
//     </Box>

//     {/* Section 3: Contact Info Skeleton */}
//     <Box>
//       <Typography
//         variant="h6"
//         component="h1"
//         gutterBottom
//         sx={{ fontWeight: "bold" }}
//       >
//         <Skeleton width="40%" />
//       </Typography>
//       <Divider sx={{ my: 2, bgcolor: primaryPurple, mb: 3 }} />
//       <Grid container spacing={3}>
//         <Grid item xs={12} sm={6}>
//           <Skeleton
//             variant="rectangular"
//             height={56}
//             sx={{ borderRadius: "8px" }}
//           />
//         </Grid>
//         <Grid item xs={12} sm={6}>
//           <Skeleton
//             variant="rectangular"
//             height={56}
//             sx={{ borderRadius: "8px" }}
//           />
//         </Grid>
//       </Grid>
//     </Box>

//     {/* Section 4: Save Button Skeleton */}
//     <Box sx={{ mt: 4, display: "flex", justifyContent: "flex-end" }}>
//       <Skeleton
//         variant="rectangular"
//         width={140}
//         height={42}
//         sx={{ borderRadius: "4px" }}
//       />
//     </Box>
//   </Box>
// );

// const CompanyDetailsFields = ({
//   data,
//   handleInputChange,
//   logoPreviewUrl,
//   handleFileChange,
// }) => (
//   <Box>
//     <Typography
//       variant="h6"
//       component="h1"
//       gutterBottom
//       sx={{ color: primaryPurple, fontWeight: "bold" }}
//     >
//       Company Details
//     </Typography>
//     <Divider sx={{ my: 2, bgcolor: primaryPurple, mb: 3 }} />
//     <Grid container spacing={3} alignItems="center">
//       <Grid item xs={12} md={8}>
//         <Grid container spacing={2}>
//           <Grid item xs={12} sm={4}>
//             <TextField
//               fullWidth
//               label="Company name"
//               name="company_name"
//               value={data.company_name}
//               onChange={(e) =>
//                 handleInputChange("company_name", e.target.value)
//               }
//             />
//           </Grid>
//           <Grid item xs={12} sm={4}>
//             <TextField
//               fullWidth
//               label="Websites"
//               name="website"
//               value={data.website}
//               onChange={(e) => handleInputChange("website", e.target.value)}
//             />
//           </Grid>
//           <Grid item xs={12} sm={4}>
//             <TextField
//               fullWidth
//               label="Location"
//               name="headquarters"
//               value={data.headquarters}
//               onChange={(e) =>
//                 handleInputChange("headquarters", e.target.value)
//               }
//             />
//           </Grid>
//           <Grid item xs={12} sm={4}>
//             <TextField
//               fullWidth
//               type="date"
//               label="Founded Date"
//               name="founded_date"
//               value={data.founded_date}
//               onChange={(e) =>
//                 handleInputChange("founded_date", e.target.value)
//               }
//               InputLabelProps={{ shrink: true }}
//             />
//           </Grid>
//           <Grid item xs={12} sm={4}>
//             <FormControl fullWidth>
//               <InputLabel id="industry-label">Industry</InputLabel>
//               <Select
//                 labelId="industry-label"
//                 label="Industry"
//                 name="industry"
//                 value={data.industry}
//                 onChange={(e) => handleInputChange("industry", e.target.value)}
//               >
//                 {industryOptions.map((option) => (
//                   <MenuItem key={option.value} value={option.value}>
//                     {option.label}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>
//           <Grid item xs={12} sm={4}>
//             <FormControl fullWidth>
//               <InputLabel id="size-label">Company Size</InputLabel>
//               <Select
//                 labelId="size-label"
//                 label="Company Size"
//                 name="size"
//                 value={data.size}
//                 onChange={(e) => handleInputChange("size", e.target.value)}
//               >
//                 {sizeOptions.map((option) => (
//                   <MenuItem key={option.value} value={option.value}>
//                     {option.label}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>
//         </Grid>
//       </Grid>
//       <Grid
//         item
//         xs={12}
//         md={4}
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "center",
//           alignItems: "center",
//           gap: 2,
//         }}
//       >
//         <Avatar
//           src={logoPreviewUrl}
//           sx={{ width: 100, height: 100, border: `2px solid ${primaryPurple}` }}
//         />
//         <Button
//           variant="outlined"
//           component="label"
//           sx={{
//             color: primaryPurple,
//             borderColor: primaryPurple,
//             "&:hover": {
//               borderColor: primaryPurple,
//               backgroundColor: "rgba(79, 70, 186, 0.04)",
//             },
//           }}
//         >
//           {logoPreviewUrl ? "Change Logo" : "Upload Logo"}
//           <input
//             type="file"
//             hidden
//             accept="image/*"
//             onChange={handleFileChange}
//           />
//         </Button>
//       </Grid>
//     </Grid>
//   </Box>
// );

// const CompanyDescription = ({ data, handleInputChange }) => (
//   <Box sx={{ my: 3 }}>
//     <Typography
//       variant="h6"
//       component="h1"
//       gutterBottom
//       sx={{ color: primaryPurple, fontWeight: "bold" }}
//     >
//       Company Description
//     </Typography>
//     <Divider sx={{ my: 2, bgcolor: primaryPurple, mb: 3 }} />
//     <TextField
//       fullWidth
//       multiline
//       rows={4}
//       label="A leading tech company."
//       value={data.description}
//       onChange={(e) => handleInputChange("description", e.target.value)}
//     />
//   </Box>
// );

// const ContactInfoFields = ({ data, handleInputChange }) => (
//   <Box>
//     <Typography
//       variant="h6"
//       component="h1"
//       gutterBottom
//       sx={{ color: primaryPurple, fontWeight: "bold" }}
//     >
//       Contact Information
//     </Typography>
//     <Divider sx={{ my: 2, bgcolor: primaryPurple, mb: 3 }} />
//     <Grid container spacing={3}>
//       <Grid item xs={12} sm={6}>
//         <TextField
//           fullWidth
//           type="email"
//           label="Contact Email"
//           value={data.contact_email}
//           onChange={(e) => handleInputChange("contact_email", e.target.value)}
//         />
//       </Grid>
//       <Grid item xs={12} sm={6}>
//         <TextField
//           fullWidth
//           type="tel"
//           label="Phone Number"
//           value={data.phone_number}
//           onChange={(e) => handleInputChange("phone_number", e.target.value)}
//         />
//       </Grid>
//     </Grid>
//   </Box>
// );

// const CompanyProfile = () => {
//   const [companyData, setCompanyData] = useState({
//     company_name: "",
//     description: "",
//     industry: "",
//     website: "",
//     headquarters: "",
//     size: "",
//     founded_date: "",
//     contact_email: "",
//     phone_number: "",
//   });
//   const [companyId, setCompanyId] = useState(null);
//   const [logoFile, setLogoFile] = useState(null);
//   const [logoPreviewUrl, setLogoPreviewUrl] = useState("");
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchCompanyData = async () => {
//       setLoading(true);
//       if (!localStorage.getItem("access_token")) {
//         showNotification("You must be logged in to view this page.", "error");
//         setLoading(false);
//         return;
//       }
//       try {
//         const response = await apiClient.get(`/mycompany/`);
//         const data = response.data;
//         setCompanyData({
//           company_name: data.company_name || "",
//           description: data.description || "",
//           industry: data.industry || "",
//           website: data.website || "",
//           headquarters: data.headquarters || "",
//           size: data.size || "",
//           founded_date: data.founded_date || "",
//           contact_email: data.contact_email || "",
//           phone_number: data.phone_number || "",
//         });
//         setCompanyId(data.id);
//         if (data.logo) {
//           // Assuming apiClient.defaults.baseURL is already set
//           setLogoPreviewUrl(data.logo);
//         }
//       } catch (error) {
//         if (error.response && error.response.status === 404) {
//           showNotification(
//             "No company profile found. Please create one.",
//             "info"
//           );
//         } else {
//           console.error("Failed to fetch company data:", error);
//           showNotification("Could not load your company profile.", "error");
//         }
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchCompanyData();
//   }, []);

//   useEffect(() => {
//     return () => {
//       if (logoPreviewUrl && logoPreviewUrl.startsWith("blob:")) {
//         URL.revokeObjectURL(logoPreviewUrl);
//       }
//     };
//   }, [logoPreviewUrl]);

//   const handleInputChange = (field, value) => {
//     setCompanyData((prev) => ({ ...prev, [field]: value }));
//   };

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       setLogoFile(file);
//       if (logoPreviewUrl && logoPreviewUrl.startsWith("blob:")) {
//         URL.revokeObjectURL(logoPreviewUrl);
//       }
//       setLogoPreviewUrl(URL.createObjectURL(file));
//     }
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     setLoading(true);

//     if (!localStorage.getItem("access_token")) {
//       showNotification("Authentication error: Not logged in.", "error");
//       setLoading(false);
//       return;
//     }

//     if (
//       !companyData.company_name ||
//       !companyData.industry ||
//       !companyData.contact_email
//     ) {
//       showNotification(
//         "Please fill in all required fields: Company Name, Industry, and Contact Email.",
//         "error"
//       );
//       setLoading(false);
//       return;
//     }

//     const formData = new FormData();
//     Object.keys(companyData).forEach((key) => {
//       if (companyData[key]) formData.append(key, companyData[key]);
//     });

//     if (logoFile) {
//       const sanitizedCompanyName = companyData.company_name
//         .trim()
//         .toLowerCase()
//         .replace(/\s+/g, "-")
//         .replace(/[^a-z0-9-]/g, "");
//       const fileExtension = logoFile.name.split(".").pop();
//       const newFilename = `${sanitizedCompanyName}-logo.${fileExtension}`;
//       formData.append("logo", logoFile, newFilename);
//     }

//     const isUpdate = !!companyId;
//     const API_URL = isUpdate ? `/update-company/` : `/companies/`;
//     const method = isUpdate ? "put" : "post";

//     try {
//       const response = await apiClient({
//         method: method,
//         url: API_URL,
//         data: formData,
//         headers: { "Content-Type": "multipart/form-data" },
//       });
//       showNotification(
//         `Profile ${isUpdate ? "updated" : "created"} successfully!`,
//         "success"
//       );

//       const responseData = response.data;
//       if (responseData.logo) {
//         setLogoPreviewUrl(responseData.logo);
//       }
//       setLogoFile(null);

//       if (!companyId && responseData.id) setCompanyId(responseData.id);
//     } catch (error) {
//       let errorMessage = `Failed to ${isUpdate ? "update" : "create"} profile.`;
//       if (error.response) {
//         console.error("API Error Response:", error.response.data);
//         errorMessage = `Server Error: ${
//           error.response.status
//         }. ${JSON.stringify(error.response.data)}`;
//       } else {
//         console.error("Request/Network Error:", error.message);
//         errorMessage = "Network error. Please check your connection.";
//       }
//       showNotification(errorMessage, "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <ThemeProvider theme={theme}>
//       <Layout title="Company Profile">
//         <Box component="main" sx={{ p: { xs: 2, md: 3 }, flexGrow: 1 }}>
//           <Paper
//             sx={{
//               p: 3,
//               mb: 3,
//               backgroundColor: lightBackground,
//               borderRadius: "12px",
//             }}
//           >
//             {loading ? (
//               <>
//                 <Skeleton
//                   variant="text"
//                   width="40%"
//                   height={48}
//                   sx={{ mb: 1 }}
//                 />
//                 <Skeleton variant="text" width="70%" />
//               </>
//             ) : (
//               <>
//                 <Typography
//                   variant="h5"
//                   component="h1"
//                   gutterBottom
//                   sx={{ color: primaryPurple, fontWeight: "bold" }}
//                 >
//                   {companyId
//                     ? "Edit Company Profile"
//                     : "Create Company Profile"}
//                 </Typography>
//                 <Typography variant="body1" color={textBlack}>
//                   {companyId
//                     ? "Update your company's details. This information will be visible to candidates."
//                     : "Provide your company's details to get started."}
//                 </Typography>
//               </>
//             )}
//           </Paper>

//           <Paper
//             component="form"
//             onSubmit={handleSubmit}
//             sx={{
//               backgroundColor: lightBackground,
//               borderRadius: "12px",
//               boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
//               p: { xs: 2, md: 4 },
//             }}
//           >
//             <CardContent>
//               {loading ? (
//                 <FormSkeleton />
//               ) : (
//                 <>
//                   <CompanyDetailsFields
//                     data={companyData}
//                     handleInputChange={handleInputChange}
//                     logoPreviewUrl={logoPreviewUrl}
//                     handleFileChange={handleFileChange}
//                   />
//                   <CompanyDescription
//                     data={companyData}
//                     handleInputChange={handleInputChange}
//                   />
//                   <ContactInfoFields
//                     data={companyData}
//                     handleInputChange={handleInputChange}
//                   />

//                   <Box
//                     sx={{
//                       mt: 4,
//                       display: "flex",
//                       justifyContent: "flex-end",
//                       alignItems: "center",
//                       flexWrap: "wrap",
//                       gap: 2,
//                     }}
//                   >
//                     <Button
//                       type="submit"
//                       variant="contained"
//                       startIcon={<Save />}
//                       size="large"
//                       disabled={loading}
//                     >
//                       {loading ? "Saving..." : "Save Profile"}
//                     </Button>
//                   </Box>
//                 </>
//               )}
//             </CardContent>
//           </Paper>
//         </Box>
//       </Layout>
//     </ThemeProvider>
//   );
// };

// export default CompanyProfile;


// import { useState, useEffect } from "react";
// import {
//   Grid,
//   CardContent,
//   Typography,
//   TextField,
//   Button,
//   Box,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Divider,
//   Skeleton,
//   Paper,
//   Avatar,
// } from "@mui/material";
// import { Save } from "@mui/icons-material";

// import apiClient from "../../context/apiClient";
// import Layout from "../common/Layout";

// const showNotification = (message, severity) => {
//   console.log(`[${severity.toUpperCase()}] Notification: ${message}`);
// };

// const industryOptions = [
//   { value: "IT_SOFTWARE", label: "IT & Software" },
//   { value: "FINANCE", label: "Finance & Banking" },
//   { value: "HEALTHCARE", label: "Healthcare" },
//   { value: "ECOMMERCE", label: "E-commerce & Retail" },
//   { value: "EDUCATION", label: "Education" },
//   { value: "MANUFACTURING", label: "Manufacturing" },
//   { value: "OTHER", label: "Other" },
// ];

// const sizeOptions = [
//   { value: "1-10", label: "Startup (1-10)" },
//   { value: "11-50", label: "Small (11-50)" },
//   { value: "51-200", label: "Medium (51-200)" },
//   { value: "201-500", label: "Large (201-500)" },
//   { value: "501-1000", label: "Enterprise (501-1000)" },
//   { value: "1001-5000", label: "Tier 2 (1001-5000)" },
//   { value: "5000+", label: "Global (5000+)" },
// ];

// const FormSkeleton = () => (
//   <Box>
//     <Typography
//       variant="h6"
//       component="h1"
//       gutterBottom
//       sx={{ fontWeight: "bold" }}
//     >
//       <Skeleton width="35%" />
//     </Typography>
//     <Divider sx={{ my: 2, bgcolor: "primary.main", mb: 3 }} />
//     <Grid container spacing={3} alignItems="center">
//       <Grid item xs={12} md={8}>
//         <Grid container spacing={2}>
//           {[...Array(6)].map((_, i) => (
//             <Grid item xs={12} sm={4} key={i}>
//               <Skeleton
//                 variant="rectangular"
//                 height={56}
//                 sx={{ borderRadius: "8px" }}
//               />
//             </Grid>
//           ))}
//         </Grid>
//       </Grid>
//       <Grid
//         item
//         xs={12}
//         md={4}
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "center",
//           alignItems: "center",
//           gap: 2,
//         }}
//       >
//         <Skeleton variant="circular" width={100} height={100} />
//         <Skeleton
//           variant="rectangular"
//           width={120}
//           height={36}
//           sx={{ borderRadius: "4px" }}
//         />
//       </Grid>
//     </Grid>
//     <Box sx={{ my: 3 }}>
//       <Typography
//         variant="h6"
//         component="h1"
//         gutterBottom
//         sx={{ fontWeight: "bold" }}
//       >
//         <Skeleton width="45%" />
//       </Typography>
//       <Divider sx={{ my: 2, bgcolor: "primary.main", mb: 3 }} />
//       <Skeleton
//         variant="rectangular"
//         height={118}
//         sx={{ borderRadius: "8px" }}
//       />
//     </Box>
//     <Box>
//       <Typography
//         variant="h6"
//         component="h1"
//         gutterBottom
//         sx={{ fontWeight: "bold" }}
//       >
//         <Skeleton width="40%" />
//       </Typography>
//       <Divider sx={{ my: 2, bgcolor: "primary.main", mb: 3 }} />
//       <Grid container spacing={3}>
//         <Grid item xs={12} sm={6}>
//           <Skeleton
//             variant="rectangular"
//             height={56}
//             sx={{ borderRadius: "8px" }}
//           />
//         </Grid>
//         <Grid item xs={12} sm={6}>
//           <Skeleton
//             variant="rectangular"
//             height={56}
//             sx={{ borderRadius: "8px" }}
//           />
//         </Grid>
//       </Grid>
//     </Box>
//     <Box sx={{ mt: 4, display: "flex", justifyContent: "flex-end" }}>
//       <Skeleton
//         variant="rectangular"
//         width={140}
//         height={42}
//         sx={{ borderRadius: "4px" }}
//       />
//     </Box>
//   </Box>
// );

// const CompanyDetailsFields = ({
//   data,
//   handleInputChange,
//   logoPreviewUrl,
//   handleFileChange,
// }) => (
//   <Box>
//     <Typography
//       variant="h6"
//       component="h1"
//       gutterBottom
//       sx={{ color: "primary.main", fontWeight: "bold" }}
//     >
//       Company Details
//     </Typography>
//     <Divider sx={{ my: 2, bgcolor: "primary.main", mb: 3 }} />
//     <Grid container spacing={3} alignItems="center">
//       <Grid item xs={12} md={8}>
//         <Grid container spacing={2}>
//           <Grid item xs={12} sm={4}>
//             <TextField
//               fullWidth
//               label="Company name"
//               name="company_name"
//               value={data.company_name}
//               onChange={(e) =>
//                 handleInputChange("company_name", e.target.value)
//               }
//             />
//           </Grid>
//           <Grid item xs={12} sm={4}>
//             <TextField
//               fullWidth
//               label="Websites"
//               name="website"
//               value={data.website}
//               onChange={(e) => handleInputChange("website", e.target.value)}
//             />
//           </Grid>
//           <Grid item xs={12} sm={4}>
//             <TextField
//               fullWidth
//               label="Location"
//               name="headquarters"
//               value={data.headquarters}
//               onChange={(e) =>
//                 handleInputChange("headquarters", e.target.value)
//               }
//             />
//           </Grid>
//           <Grid item xs={12} sm={4}>
//             <TextField
//               fullWidth
//               type="date"
//               label="Founded Date"
//               name="founded_date"
//               value={data.founded_date}
//               onChange={(e) =>
//                 handleInputChange("founded_date", e.target.value)
//               }
//               InputLabelProps={{ shrink: true }}
//             />
//           </Grid>
//           <Grid item xs={12} sm={4}>
//             <FormControl fullWidth>
//               <InputLabel id="industry-label">Industry</InputLabel>
//               <Select
//                 labelId="industry-label"
//                 label="Industry"
//                 name="industry"
//                 value={data.industry}
//                 onChange={(e) => handleInputChange("industry", e.target.value)}
//               >
//                 {industryOptions.map((option) => (
//                   <MenuItem key={option.value} value={option.value}>
//                     {option.label}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>
//           <Grid item xs={12} sm={4}>
//             <FormControl fullWidth>
//               <InputLabel id="size-label">Company Size</InputLabel>
//               <Select
//                 labelId="size-label"
//                 label="Company Size"
//                 name="size"
//                 value={data.size}
//                 onChange={(e) => handleInputChange("size", e.target.value)}
//               >
//                 {sizeOptions.map((option) => (
//                   <MenuItem key={option.value} value={option.value}>
//                     {option.label}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>
//         </Grid>
//       </Grid>
//       <Grid
//         item
//         xs={12}
//         md={4}
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "center",
//           alignItems: "center",
//           gap: 2,
//         }}
//       >
//         <Avatar
//           src={logoPreviewUrl}
//           sx={{
//             width: 100,
//             height: 100,
//             border: `2px solid`,
//             borderColor: "primary.main",
//           }}
//         />
//         <Button variant="outlined" component="label" color="primary">
//           {logoPreviewUrl ? "Change Logo" : "Upload Logo"}
//           <input
//             type="file"
//             hidden
//             accept="image/*"
//             onChange={handleFileChange}
//           />
//         </Button>
//       </Grid>
//     </Grid>
//   </Box>
// );

// const CompanyDescription = ({ data, handleInputChange }) => (
//   <Box sx={{ my: 3 }}>
//     <Typography
//       variant="h6"
//       component="h1"
//       gutterBottom
//       sx={{ color: "primary.main", fontWeight: "bold" }}
//     >
//       Company Description
//     </Typography>
//     <Divider sx={{ my: 2, bgcolor: "primary.main", mb: 3 }} />
//     <TextField
//       fullWidth
//       multiline
//       rows={4}
//       label="A leading tech company."
//       value={data.description}
//       onChange={(e) => handleInputChange("description", e.target.value)}
//     />
//   </Box>
// );

// const ContactInfoFields = ({ data, handleInputChange }) => (
//   <Box>
//     <Typography
//       variant="h6"
//       component="h1"
//       gutterBottom
//       sx={{ color: "primary.main", fontWeight: "bold" }}
//     >
//       Contact Information
//     </Typography>
//     <Divider sx={{ my: 2, bgcolor: "primary.main", mb: 3 }} />
//     <Grid container spacing={3}>
//       <Grid item xs={12} sm={6}>
//         <TextField
//           fullWidth
//           type="email"
//           label="Contact Email"
//           value={data.contact_email}
//           onChange={(e) => handleInputChange("contact_email", e.target.value)}
//         />
//       </Grid>
//       <Grid item xs={12} sm={6}>
//         <TextField
//           fullWidth
//           type="tel"
//           label="Phone Number"
//           value={data.phone_number}
//           onChange={(e) => handleInputChange("phone_number", e.target.value)}
//         />
//       </Grid>
//     </Grid>
//   </Box>
// );

// const CompanyProfile = () => {
//   const [companyData, setCompanyData] = useState({
//     company_name: "",
//     description: "",
//     industry: "",
//     website: "",
//     headquarters: "",
//     size: "",
//     founded_date: "",
//     contact_email: "",
//     phone_number: "",
//   });
//   const [companyId, setCompanyId] = useState(null);
//   const [logoFile, setLogoFile] = useState(null);
//   const [logoPreviewUrl, setLogoPreviewUrl] = useState("");
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchCompanyData = async () => {
//       setLoading(true);
//       if (!localStorage.getItem("access_token")) {
//         showNotification("You must be logged in to view this page.", "error");
//         setLoading(false);
//         return;
//       }
//       try {
//         const response = await apiClient.get(`/mycompany/`);
//         const data = response.data;
//         setCompanyData({
//           company_name: data.company_name || "",
//           description: data.description || "",
//           industry: data.industry || "",
//           website: data.website || "",
//           headquarters: data.headquarters || "",
//           size: data.size || "",
//           founded_date: data.founded_date || "",
//           contact_email: data.contact_email || "",
//           phone_number: data.phone_number || "",
//         });
//         setCompanyId(data.id);
//         if (data.logo) {
//           setLogoPreviewUrl(data.logo);
//         }
//       } catch (error) {
//         if (error.response && error.response.status === 404) {
//           showNotification(
//             "No company profile found. Please create one.",
//             "info"
//           );
//         } else {
//           console.error("Failed to fetch company data:", error);
//           showNotification("Could not load your company profile.", "error");
//         }
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchCompanyData();
//   }, []);

//   useEffect(() => {
//     return () => {
//       if (logoPreviewUrl && logoPreviewUrl.startsWith("blob:")) {
//         URL.revokeObjectURL(logoPreviewUrl);
//       }
//     };
//   }, [logoPreviewUrl]);

//   const handleInputChange = (field, value) => {
//     setCompanyData((prev) => ({ ...prev, [field]: value }));
//   };

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       setLogoFile(file);
//       if (logoPreviewUrl && logoPreviewUrl.startsWith("blob:")) {
//         URL.revokeObjectURL(logoPreviewUrl);
//       }
//       setLogoPreviewUrl(URL.createObjectURL(file));
//     }
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     setLoading(true);

//     if (!localStorage.getItem("access_token")) {
//       showNotification("Authentication error: Not logged in.", "error");
//       setLoading(false);
//       return;
//     }

//     if (
//       !companyData.company_name ||
//       !companyData.industry ||
//       !companyData.contact_email
//     ) {
//       showNotification(
//         "Please fill in all required fields: Company Name, Industry, and Contact Email.",
//         "error"
//       );
//       setLoading(false);
//       return;
//     }

//     const formData = new FormData();
//     Object.keys(companyData).forEach((key) => {
//       if (companyData[key]) formData.append(key, companyData[key]);
//     });

//     if (logoFile) {
//       const sanitizedCompanyName = companyData.company_name
//         .trim()
//         .toLowerCase()
//         .replace(/\s+/g, "-")
//         .replace(/[^a-z0-9-]/g, "");
//       const fileExtension = logoFile.name.split(".").pop();
//       const newFilename = `${sanitizedCompanyName}-logo.${fileExtension}`;
//       formData.append("logo", logoFile, newFilename);
//     }

//     const isUpdate = !!companyId;
//     const API_URL = isUpdate ? `/update-company/` : `/companies/`;
//     const method = isUpdate ? "put" : "post";

//     try {
//       const response = await apiClient({
//         method: method,
//         url: API_URL,
//         data: formData,
//         headers: { "Content-Type": "multipart/form-data" },
//       });
//       showNotification(
//         `Profile ${isUpdate ? "updated" : "created"} successfully!`,
//         "success"
//       );

//       const responseData = response.data;
//       if (responseData.logo) {
//         setLogoPreviewUrl(responseData.logo);
//       }
//       setLogoFile(null);

//       if (!companyId && responseData.id) setCompanyId(responseData.id);
//     } catch (error) {
//       let errorMessage = `Failed to ${isUpdate ? "update" : "create"} profile.`;
//       if (error.response) {
//         console.error("API Error Response:", error.response.data);
//         errorMessage = `Server Error: ${
//           error.response.status
//         }. ${JSON.stringify(error.response.data)}`;
//       } else {
//         console.error("Request/Network Error:", error.message);
//         errorMessage = "Network error. Please check your connection.";
//       }
//       showNotification(errorMessage, "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Layout title="Company Profile">
//       <Box component="main" sx={{ p: { xs: 2, md: 3 }, flexGrow: 1 }}>
//         <Paper
//           sx={{
//             p: 3,
//             mb: 3,
//             backgroundColor: "mint.main",
//             borderRadius: "12px",
//           }}
//         >
//           {loading ? (
//             <>
//               <Skeleton variant="text" width="40%" height={48} sx={{ mb: 1 }} />
//               <Skeleton variant="text" width="70%" />
//             </>
//           ) : (
//             <>
//               <Typography
//                 variant="h5"
//                 component="h1"
//                 gutterBottom
//                 sx={{ color: "primary.main", fontWeight: "bold" }}
//               >
//                 {companyId ? "Edit Company Profile" : "Create Company Profile"}
//               </Typography>
//               <Typography variant="body1" color="text.primary">
//                 {companyId
//                   ? "Update your company's details. This information will be visible to candidates."
//                   : "Provide your company's details to get started."}
//               </Typography>
//             </>
//           )}
//         </Paper>

//         <Paper
//           component="form"
//           onSubmit={handleSubmit}
//           sx={{
//             backgroundColor: "mint.main",
//             borderRadius: "12px",
//             boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
//             p: { xs: 2, md: 4 },
//           }}
//         >
//           <CardContent>
//             {loading ? (
//               <FormSkeleton />
//             ) : (
//               <>
//                 <CompanyDetailsFields
//                   data={companyData}
//                   handleInputChange={handleInputChange}
//                   logoPreviewUrl={logoPreviewUrl}
//                   handleFileChange={handleFileChange}
//                 />
//                 <CompanyDescription
//                   data={companyData}
//                   handleInputChange={handleInputChange}
//                 />
//                 <ContactInfoFields
//                   data={companyData}
//                   handleInputChange={handleInputChange}
//                 />

//                 <Box
//                   sx={{
//                     mt: 4,
//                     display: "flex",
//                     justifyContent: "flex-end",
//                     alignItems: "center",
//                     flexWrap: "wrap",
//                     gap: 2,
//                   }}
//                 >
//                   <Button
//                     type="submit"
//                     variant="contained"
//                     startIcon={<Save />}
//                     size="large"
//                     disabled={loading}
//                   >
//                     {loading ? "Saving..." : "Save Profile"}
//                   </Button>
//                 </Box>
//               </>
//             )}
//           </CardContent>
//         </Paper>
//       </Box>
//     </Layout>
//   );
// };

// export default CompanyProfile;












// import { useState, useEffect } from "react";
// import {
//   Grid,
//   CardContent,
//   Typography,
//   TextField,
//   Button,
//   Box,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Container,
//   Divider,
//   Skeleton,
//   Paper,
//   Avatar,
// } from "@mui/material";
// import { Save } from "@mui/icons-material";

// import apiClient from "../../context/apiClient";
// import Layout from "../common/Layout";

// const showNotification = (message, severity) => {
//   console.log(`[${severity.toUpperCase()}] Notification: ${message}`);
// };

// // This array needs to be accessible by CompanyDetailsFields
// const industryOptions = [
//   { value: "IT_SOFTWARE", label: "IT & Software" },
//   { value: "FINANCE", label: "Finance & Banking" },
//   { value: "HEALTHCARE", label: "Healthcare" },
//   { value: "ECOMMERCE", label: "E-commerce & Retail" },
//   { value: "EDUCATION", label: "Education" },
//   { value: "MANUFACTURING", label: "Manufacturing" },
//   { value: "OTHER", label: "Other" },
// ];

// // This array also needs to be accessible by CompanyDetailsFields
// const sizeOptions = [
//   { value: "1-10", label: "Startup (1-10)" },
//   { value: "11-50", label: "Small (11-50)" },
//   { value: "51-200", label: "Medium (51-200)" },
//   { value: "201-500", label: "Large (201-500)" },
//   { value: "501-1000", label: "Enterprise (501-1000)" },
//   { value: "1001-5000", label: "Tier 2 (1001-5000)" },
//   { value: "5000+", label: "Global (5000+)" },
// ];

// const FormSkeleton = () => (
//   <Box>
//     <Typography
//       variant="h6"
//       component="h1"
//       gutterBottom
//       sx={{ fontWeight: "bold" }}
//     >
//       <Skeleton width="35%" />
//     </Typography>
//     <Divider sx={{ my: 2, bgcolor: "primary.main", mb: 3 }} />
//     <Grid container spacing={3} alignItems="center">
//       <Grid item xs={12} md={8}>
//         <Grid container spacing={2}>
//           {[...Array(6)].map((_, i) => (
//             <Grid item xs={12} sm={4} key={i}>
//               <Skeleton
//                 variant="rectangular"
//                 height={56}
//                 sx={{ borderRadius: "8px" }}
//               />
//             </Grid>
//           ))}
//         </Grid>
//       </Grid>
//       <Grid
//         item
//         xs={12}
//         md={4}
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "center",
//           alignItems: "center",
//           gap: 2,
//         }}
//       >
//         <Skeleton variant="circular" width={100} height={100} />
//         <Skeleton
//           variant="rectangular"
//           width={120}
//           height={36}
//           sx={{ borderRadius: "4px" }}
//         />
//       </Grid>
//     </Grid>
//     <Box sx={{ my: 3 }}>
//       <Typography
//         variant="h6"
//         component="h1"
//         gutterBottom
//         sx={{ fontWeight: "bold" }}
//       >
//         <Skeleton width="45%" />
//       </Typography>
//       <Divider sx={{ my: 2, bgcolor: "primary.main", mb: 3 }} />
//       <Skeleton
//         variant="rectangular"
//         height={118}
//         sx={{ borderRadius: "8px" }}
//       />
//     </Box>
//     <Box>
//       <Typography
//         variant="h6"
//         component="h1"
//         gutterBottom
//         sx={{ fontWeight: "bold" }}
//       >
//         <Skeleton width="40%" />
//       </Typography>
//       <Divider sx={{ my: 2, bgcolor: "primary.main", mb: 3 }} />
//       <Grid container spacing={3}>
//         <Grid item xs={12} sm={6}>
//           <Skeleton
//             variant="rectangular"
//             height={56}
//             sx={{ borderRadius: "8px" }}
//           />
//         </Grid>
//         <Grid item xs={12} sm={6}>
//           <Skeleton
//             variant="rectangular"
//             height={56}
//             sx={{ borderRadius: "8px" }}
//           />
//         </Grid>
//       </Grid>
//     </Box>
//     <Box sx={{ mt: 4, display: "flex", justifyContent: "flex-end" }}>
//       <Skeleton
//         variant="rectangular"
//         width={140}
//         height={42}
//         sx={{ borderRadius: "4px" }}
//       />
//     </Box>
//   </Box>
// );

// // This is the updated component with the sm={6} fix
// const CompanyDetailsFields = ({
//   data,
//   handleInputChange,
//   logoPreviewUrl,
//   handleFileChange,
// }) => (
//   <Box>
//     <Typography
//       variant="h6"
//       component="h1"
//       gutterBottom
//       sx={{ color: "primary.main", fontWeight: "bold" }}
//     >
//       Company Details
//     </Typography>
//     <Divider sx={{ my: 2, bgcolor: "primary.main", mb: 3 }} />
//     <Grid container spacing={3} alignItems="center">
//       <Grid
//         item
//         xs={12}
//         md={4}
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "center",
//           alignItems: "center",
//           gap: 2,
//         }}
//       >
//         <Avatar
//           src={logoPreviewUrl}
//           sx={{
//             width: 100,
//             height: 100,
//             border: `2px solid`,
//             borderColor: "primary.main",
//           }}
//         />
//         <Button variant="outlined" component="label" color="primary">
//           {logoPreviewUrl ? "Change Logo" : "Upload Logo"}
//           <input
//             type="file"
//             hidden
//             accept="image/*"
//             onChange={handleFileChange}
//           />
//         </Button>
//       </Grid>
//       <Grid item xs={12} md={8}>
//         <Grid container spacing={2}>
//           {/* Changed sm={4} to sm={6} for a two-column layout */}
//           <Grid item xs={12} sm={6}>
//             <TextField
//               fullWidth
//               label="Company name"
//               name="company_name"
//               value={data.company_name}
//               onChange={(e) =>
//                 handleInputChange("company_name", e.target.value)
//               }
//             />
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <TextField
//               fullWidth
//               label="Website"
//               name="website"
//               value={data.website}
//               onChange={(e) => handleInputChange("website", e.target.value)}
//             />
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <TextField
//               fullWidth
//               label="Location"
//               name="headquarters"
//               value={data.headquarters}
//               onChange={(e) =>
//                 handleInputChange("headquarters", e.target.value)
//               }
//             />
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <TextField
//               fullWidth
//               type="date"
//               label="Founded Date"
//               name="founded_date"
//               value={data.founded_date}
//               onChange={(e) =>
//                 handleInputChange("founded_date", e.target.value)
//               }
//               InputLabelProps={{ shrink: true }}
//             />
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <FormControl fullWidth>
//               <InputLabel id="industry-label">Industry</InputLabel>
//               <Select
//                 labelId="industry-label"
//                 label="Industry"
//                 name="industry"
//                 value={data.industry}
//                 onChange={(e) => handleInputChange("industry", e.target.value)}
//               >
//                 {industryOptions.map((option) => (
//                   <MenuItem key={option.value} value={option.value}>
//                     {option.label}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <FormControl fullWidth>
//               <InputLabel id="size-label">Company Size</InputLabel>
//               <Select
//                 labelId="size-label"
//                 label="Company Size"
//                 name="size"
//                 value={data.size}
//                 onChange={(e) => handleInputChange("size", e.target.value)}
//               >
//                 {sizeOptions.map((option) => (
//                   <MenuItem key={option.value} value={option.value}>
//                     {option.label}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>
//         </Grid>
//       </Grid>
//     </Grid>
//   </Box>
// );

// const CompanyDescription = ({ data, handleInputChange }) => (
//   <Box sx={{ my: 3 }}>
//     <Typography
//       variant="h6"
//       component="h1"
//       gutterBottom
//       sx={{ color: "primary.main", fontWeight: "bold" }}
//     >
//       Company Description
//     </Typography>
//     <Divider sx={{ my: 2, bgcolor: "primary.main", mb: 3 }} />
//     <TextField
//       fullWidth
//       multiline
//       rows={4}
//       label="A leading tech company."
//       value={data.description}
//       onChange={(e) => handleInputChange("description", e.target.value)}
//     />
//   </Box>
// );

// const ContactInfoFields = ({ data, handleInputChange }) => (
//   <Box>
//     <Typography
//       variant="h6"
//       component="h1"
//       gutterBottom
//       sx={{ color: "primary.main", fontWeight: "bold" }}
//     >
//       Contact Information
//     </Typography>
//     <Divider sx={{ my: 2, bgcolor: "primary.main", mb: 3 }} />
//     <Grid container spacing={3}>
//       <Grid item xs={12} sm={6}>
//         <TextField
//           fullWidth
//           type="email"
//           label="Contact Email"
//           value={data.contact_email}
//           onChange={(e) => handleInputChange("contact_email", e.target.value)}
//         />
//       </Grid>
//       <Grid item xs={12} sm={6}>
//         <TextField
//           fullWidth
//           type="tel"
//           label="Phone Number"
//           value={data.phone_number}
//           onChange={(e) => handleInputChange("phone_number", e.target.value)}
//         />
//       </Grid>
//     </Grid>
//   </Box>
// );

// const CompanyProfile = () => {
//   const [companyData, setCompanyData] = useState({
//     company_name: "",
//     description: "",
//     industry: "",
//     website: "",
//     headquarters: "",
//     size: "",
//     founded_date: "",
//     contact_email: "",
//     phone_number: "",
//   });
//   const [companyId, setCompanyId] = useState(null);
//   const [logoFile, setLogoFile] = useState(null);
//   const [logoPreviewUrl, setLogoPreviewUrl] = useState("");
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchCompanyData = async () => {
//       setLoading(true);
//       if (!localStorage.getItem("access_token")) {
//         showNotification("You must be logged in to view this page.", "error");
//         setLoading(false);
//         return;
//       }
//       try {
//         const response = await apiClient.get(`/mycompany/`);
//         const data = response.data;
//         setCompanyData({
//           company_name: data.company_name || "",
//           description: data.description || "",
//           industry: data.industry || "",
//           website: data.website || "",
//           headquarters: data.headquarters || "",
//           size: data.size || "",
//           founded_date: data.founded_date || "",
//           contact_email: data.contact_email || "",
//           phone_number: data.phone_number || "",
//         });
//         setCompanyId(data.id);
//         if (data.logo) {
//           setLogoPreviewUrl(data.logo);
//         }
//       } catch (error) {
//         if (error.response && error.response.status === 404) {
//           showNotification(
//             "No company profile found. Please create one.",
//             "info"
//           );
//         } else {
//           console.error("Failed to fetch company data:", error);
//           showNotification("Could not load your company profile.", "error");
//         }
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchCompanyData();
//   }, []);

//   useEffect(() => {
//     return () => {
//       if (logoPreviewUrl && logoPreviewUrl.startsWith("blob:")) {
//         URL.revokeObjectURL(logoPreviewUrl);
//       }
//     };
//   }, [logoPreviewUrl]);

//   const handleInputChange = (field, value) => {
//     setCompanyData((prev) => ({ ...prev, [field]: value }));
//   };

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       setLogoFile(file);
//       if (logoPreviewUrl && logoPreviewUrl.startsWith("blob:")) {
//         URL.revokeObjectURL(logoPreviewUrl);
//       }
//       setLogoPreviewUrl(URL.createObjectURL(file));
//     }
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     setLoading(true);

//     if (!localStorage.getItem("access_token")) {
//       showNotification("Authentication error: Not logged in.", "error");
//       setLoading(false);
//       return;
//     }

//     if (
//       !companyData.company_name ||
//       !companyData.industry ||
//       !companyData.contact_email
//     ) {
//       showNotification(
//         "Please fill in all required fields: Company Name, Industry, and Contact Email.",
//         "error"
//       );
//       setLoading(false);
//       return;
//     }

//     const formData = new FormData();
//     Object.keys(companyData).forEach((key) => {
//       if (companyData[key]) formData.append(key, companyData[key]);
//     });

//     if (logoFile) {
//       const sanitizedCompanyName = companyData.company_name
//         .trim()
//         .toLowerCase()
//         .replace(/\s+/g, "-")
//         .replace(/[^a-z0-9-]/g, "");
//       const fileExtension = logoFile.name.split(".").pop();
//       const newFilename = `${sanitizedCompanyName}-logo.${fileExtension}`;
//       formData.append("logo", logoFile, newFilename);
//     }

//     const isUpdate = !!companyId;
//     const API_URL = isUpdate ? `/update-company/` : `/companies/`;
//     const method = isUpdate ? "put" : "post";

//     try {
//       const response = await apiClient({
//         method: method,
//         url: API_URL,
//         data: formData,
//         headers: { "Content-Type": "multipart/form-data" },
//       });
//       showNotification(
//         `Profile ${isUpdate ? "updated" : "created"} successfully!`,
//         "success"
//       );

//       const responseData = response.data;
//       if (responseData.logo) {
//         setLogoPreviewUrl(responseData.logo);
//       }
//       setLogoFile(null);

//       if (!companyId && responseData.id) setCompanyId(responseData.id);
//     } catch (error) {
//       let errorMessage = `Failed to ${
//         isUpdate ? "update" : "create"
//       } profile.`;
//       if (error.response) {
//         console.error("API Error Response:", error.response.data);
//         errorMessage = `Server Error: ${
//           error.response.status
//         }. ${JSON.stringify(error.response.data)}`;
//       } else {
//         console.error("Request/Network Error:", error.message);
//         errorMessage = "Network error. Please check your connection.";
//       }
//       showNotification(errorMessage, "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Layout title="Company Profile">
//       <Container maxWidth="lg" sx={{ py: { xs: 3, md: 4 } }}>
//       <Box component="main" sx={{ p: { xs: 2, md: 3 }, flexGrow: 1 }}>
//         <Paper
//           sx={{
//             p: 3,
//             mb: 3,
//             backgroundColor: "mint.main",
//             borderRadius: "12px",
//           }}
//         >
//           {loading ? (
//             <>
//               <Skeleton variant="text" width="40%" height={48} sx={{ mb: 1 }} />
//               <Skeleton variant="text" width="70%" />
//             </>
//           ) : (
//             <>
//               <Typography
//                 variant="h4"
//                 component="h1"
//                 gutterBottom
//                 p={1}
//                 sx={{ color: "primary.main", fontWeight: "bold" }}
//               >
//                 {companyId ? "Edit Company Profile" : "Create Company Profile"}
//               </Typography>
//               <Typography variant="body1" color="text.primary">
//                 {companyId
//                   ? "Update your company's details. This information will be visible to candidates."
//                   : "Provide your company's details to get started."}
//               </Typography>
//             </>
//           )}
//         </Paper>

//         <Paper
//           component="form"
//           onSubmit={handleSubmit}
//           sx={{
//             backgroundColor: "mint.main",
//             borderRadius: "12px",
//             boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
//             p: { xs: 2, md: 4 },
//           }}
//         >
//           <CardContent>
//             {loading ? (
//               <FormSkeleton />
//             ) : (
//               <>
//                 <CompanyDetailsFields
//                   data={companyData}
//                   handleInputChange={handleInputChange}
//                   logoPreviewUrl={logoPreviewUrl}
//                   handleFileChange={handleFileChange}
//                 />
//                 <CompanyDescription
//                   data={companyData}
//                   handleInputChange={handleInputChange}
//                 />
//                 <ContactInfoFields
//                   data={companyData}
//                   handleInputChange={handleInputChange}
//                 />

//                 <Box
//                   sx={{
//                     mt: 4,
//                     display: "flex",
//                     justifyContent: "flex-end",
//                     alignItems: "center",
//                     flexWrap: "wrap",
//                     gap: 2,
//                   }}
//                 >
//                   <Button
//                     type="submit"
//                     variant="contained"
//                     startIcon={<Save />}
//                     size="large"
//                     disabled={loading}
//                   >
//                     {loading ? "Saving..." : "Save Profile"}
//                   </Button>
//                 </Box>
//               </>
//             )}
//           </CardContent>
//         </Paper>
//       </Box>
//       </Container>
    
//     </Layout>
//   );
// };

// export default CompanyProfile;




import { useState, useEffect } from "react";
import {
  Grid,
  CardContent,
  Typography,
  TextField,
  Button,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Container,
  Divider,
  Skeleton,
  Paper,
  Avatar,
} from "@mui/material";
import { Save } from "@mui/icons-material";

import apiClient from "../../context/apiClient";
import Layout from "../common/Layout";

const showNotification = (message, severity) => {
  console.log(`[${severity.toUpperCase()}] Notification: ${message}`);
};

// This array needs to be accessible by CompanyDetailsFields
const industryOptions = [
  { value: "IT_SOFTWARE", label: "IT & Software" },
  { value: "FINANCE", label: "Finance & Banking" },
  { value: "HEALTHCARE", label: "Healthcare" },
  { value: "ECOMMERCE", label: "E-commerce & Retail" },
  { value: "EDUCATION", label: "Education" },
  { value: "MANUFACTURING", label: "Manufacturing" },
  { value: "OTHER", label: "Other" },
];

// This array also needs to be accessible by CompanyDetailsFields
const sizeOptions = [
  { value: "1-10", label: "Startup (1-10)" },
  { value: "11-50", label: "Small (11-50)" },
  { value: "51-200", label: "Medium (51-200)" },
  { value: "201-500", label: "Large (201-500)" },
  { value: "501-1000", label: "Enterprise (501-1000)" },
  { value: "1001-5000", label: "Tier 2 (1001-5000)" },
  { value: "5000+", label: "Global (5000+)" },
];

const FormSkeleton = () => (
  <Box>
    <Typography
      variant="h6"
      component="h1"
      gutterBottom
      sx={{ fontWeight: "bold" }}
    >
      <Skeleton width="35%" />
    </Typography>
    <Divider sx={{ my: 2, bgcolor: "primary.main", mb: 3 }} />
    <Grid container spacing={3} alignItems="center">
      <Grid item xs={12} md={8}>
        <Grid container spacing={2}>
          {[...Array(6)].map((_, i) => (
            <Grid item xs={12} sm={4} key={i}>
              <Skeleton
                variant="rectangular"
                height={56}
                sx={{ borderRadius: "8px" }}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Skeleton variant="circular" width={100} height={100} />
        <Skeleton
          variant="rectangular"
          width={120}
          height={36}
          sx={{ borderRadius: "4px" }}
        />
      </Grid>
    </Grid>
    <Box sx={{ my: 3 }}>
      <Typography
        variant="h6"
        component="h1"
        gutterBottom
        sx={{ fontWeight: "bold" }}
      >
        <Skeleton width="45%" />
      </Typography>
      <Divider sx={{ my: 2, bgcolor: "primary.main", mb: 3 }} />
      <Skeleton
        variant="rectangular"
        height={118}
        sx={{ borderRadius: "8px" }}
      />
    </Box>
    <Box>
      <Typography
        variant="h6"
        component="h1"
        gutterBottom
        sx={{ fontWeight: "bold" }}
      >
        <Skeleton width="40%" />
      </Typography>
      <Divider sx={{ my: 2, bgcolor: "primary.main", mb: 3 }} />
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Skeleton
            variant="rectangular"
            height={56}
            sx={{ borderRadius: "8px" }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Skeleton
            variant="rectangular"
            height={56}
            sx={{ borderRadius: "8px" }}
          />
        </Grid>
      </Grid>
    </Box>
    <Box sx={{ mt: 4, display: "flex", justifyContent: "flex-end" }}>
      <Skeleton
        variant="rectangular"
        width={140}
        height={42}
        sx={{ borderRadius: "4px" }}
      />
    </Box>
  </Box>
);

const CompanyDetailsFields = ({
  data,
  handleInputChange,
  logoPreviewUrl,
  handleFileChange,
}) => (
  <Box>
    <Typography
      variant="h6"
      component="h1"
      gutterBottom
      sx={{ color: "primary.main", fontWeight: "bold" }}
    >
      Company Details
    </Typography>
    <Divider sx={{ my: 2, bgcolor: "primary.main", mb: 3 }} />
    <Grid container spacing={3} alignItems="center">
      <Grid
        item
        xs={12}
        md={4}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Avatar
          src={logoPreviewUrl}
          sx={{
            width: 100,
            height: 100,
            border: `2px solid`,
            borderColor: "primary.main",
          }}
        />
        <Button variant="outlined" component="label" color="primary">
          {logoPreviewUrl ? "Change Logo" : "Upload Logo"}
          <input
            type="file"
            hidden
            accept="image/*"
            onChange={handleFileChange}
          />
        </Button>
      </Grid>
      <Grid item xs={12} md={8}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Company name"
              name="company_name"
              value={data.company_name}
              onChange={(e) =>
                handleInputChange("company_name", e.target.value)
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Website"
              name="website"
              value={data.website}
              onChange={(e) => handleInputChange("website", e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Location"
              name="headquarters"
              value={data.headquarters}
              onChange={(e) =>
                handleInputChange("headquarters", e.target.value)
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="date"
              label="Founded Date"
              name="founded_date"
              value={data.founded_date}
              onChange={(e) =>
                handleInputChange("founded_date", e.target.value)
              }
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel id="industry-label">Industry</InputLabel>
              <Select
                labelId="industry-label"
                label="Industry"
                name="industry"
                value={data.industry}
                onChange={(e) => handleInputChange("industry", e.target.value)}
              >
                {industryOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel id="size-label">Company Size</InputLabel>
              <Select
                labelId="size-label"
                label="Company Size"
                name="size"
                value={data.size}
                onChange={(e) => handleInputChange("size", e.target.value)}
              >
                {sizeOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </Box>
);

const CompanyDescription = ({ data, handleInputChange }) => (
  <Box sx={{ my: 3 }}>
    <Typography
      variant="h6"
      component="h1"
      gutterBottom
      sx={{ color: "primary.main", fontWeight: "bold" }}
    >
      Company Description
    </Typography>
    <Divider sx={{ my: 2, bgcolor: "primary.main", mb: 3 }} />
    <TextField
      fullWidth
      multiline
      rows={4}
      label="A leading tech company."
      value={data.description}
      onChange={(e) => handleInputChange("description", e.target.value)}
    />
  </Box>
);

const ContactInfoFields = ({ data, handleInputChange }) => (
  <Box>
    <Typography
      variant="h6"
      component="h1"
      gutterBottom
      sx={{ color: "primary.main", fontWeight: "bold" }}
    >
      Contact Information
    </Typography>
    <Divider sx={{ my: 2, bgcolor: "primary.main", mb: 3 }} />
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          type="email"
          label="Contact Email"
          value={data.contact_email}
          onChange={(e) => handleInputChange("contact_email", e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          type="tel"
          label="Phone Number"
          value={data.phone_number}
          onChange={(e) => handleInputChange("phone_number", e.target.value)}
        />
      </Grid>
    </Grid>
  </Box>
);

const CompanyProfile = () => {
  const [companyData, setCompanyData] = useState({
    company_name: "",
    description: "",
    industry: "",
    website: "",
    headquarters: "",
    size: "",
    founded_date: "",
    contact_email: "",
    phone_number: "",
  });
  const [companyId, setCompanyId] = useState(null);
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreviewUrl, setLogoPreviewUrl] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCompanyData = async () => {
      setLoading(true);
      if (!localStorage.getItem("access_token")) {
        showNotification("You must be logged in to view this page.", "error");
        setLoading(false);
        return;
      }
      try {
        const response = await apiClient.get(`/mycompany/`);
        const data = response.data;
        setCompanyData({
          company_name: data.company_name || "",
          description: data.description || "",
          industry: data.industry || "",
          website: data.website || "",
          headquarters: data.headquarters || "",
          size: data.size || "",
          founded_date: data.founded_date || "",
          contact_email: data.contact_email || "",
          phone_number: data.phone_number || "",
        });
        setCompanyId(data.id);
        if (data.logo) {
          setLogoPreviewUrl(data.logo);
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          showNotification(
            "No company profile found. Please create one.",
            "info"
          );
        } else {
          console.error("Failed to fetch company data:", error);
          showNotification("Could not load your company profile.", "error");
        }
      } finally {
        setLoading(false);
      }
    };
    fetchCompanyData();
  }, []);

  useEffect(() => {
    return () => {
      if (logoPreviewUrl && logoPreviewUrl.startsWith("blob:")) {
        URL.revokeObjectURL(logoPreviewUrl);
      }
    };
  }, [logoPreviewUrl]);

  // --- MODIFIED FUNCTION WITH VALIDATION ---
  const handleInputChange = (field, value) => {
    // Validation for Location (headquarters) to allow only characters and spaces
    if (field === "headquarters") {
      const validLocationRegex = /^[a-zA-Z\s]*$/;
      if (validLocationRegex.test(value)) {
        setCompanyData((prev) => ({ ...prev, [field]: value }));
      }
    }
    // Validation for Phone Number to allow only 10 digits
    else if (field === "phone_number") {
      const validPhoneRegex = /^[0-9]*$/;
      if (validPhoneRegex.test(value) && value.length <= 10) {
        setCompanyData((prev) => ({ ...prev, [field]: value }));
      }
    }
    // Default behavior for all other fields
    else {
      setCompanyData((prev) => ({ ...prev, [field]: value }));
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setLogoFile(file);
      if (logoPreviewUrl && logoPreviewUrl.startsWith("blob:")) {
        URL.revokeObjectURL(logoPreviewUrl);
      }
      setLogoPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    if (!localStorage.getItem("access_token")) {
      showNotification("Authentication error: Not logged in.", "error");
      setLoading(false);
      return;
    }

    if (
      !companyData.company_name ||
      !companyData.industry ||
      !companyData.contact_email
    ) {
      showNotification(
        "Please fill in all required fields: Company Name, Industry, and Contact Email.",
        "error"
      );
      setLoading(false);
      return;
    }

    const formData = new FormData();
    Object.keys(companyData).forEach((key) => {
      if (companyData[key]) formData.append(key, companyData[key]);
    });

    if (logoFile) {
      const sanitizedCompanyName = companyData.company_name
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9-]/g, "");
      const fileExtension = logoFile.name.split(".").pop();
      const newFilename = `${sanitizedCompanyName}-logo.${fileExtension}`;
      formData.append("logo", logoFile, newFilename);
    }

    const isUpdate = !!companyId;
    const API_URL = isUpdate ? `/update-company/` : `/companies/`;
    const method = isUpdate ? "put" : "post";

    try {
      const response = await apiClient({
        method: method,
        url: API_URL,
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });
      showNotification(
        `Profile ${isUpdate ? "updated" : "created"} successfully!`,
        "success"
      );

      const responseData = response.data;
      if (responseData.logo) {
        setLogoPreviewUrl(responseData.logo);
      }
      setLogoFile(null);

      if (!companyId && responseData.id) setCompanyId(responseData.id);
    } catch (error) {
      let errorMessage = `Failed to ${
        isUpdate ? "update" : "create"
      } profile.`;
      if (error.response) {
        console.error("API Error Response:", error.response.data);
        errorMessage = `Server Error: ${
          error.response.status
        }. ${JSON.stringify(error.response.data)}`;
      } else {
        console.error("Request/Network Error:", error.message);
        errorMessage = "Network error. Please check your connection.";
      }
      showNotification(errorMessage, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout title="Company Profile">
      <Container maxWidth="lg" sx={{ py: { xs: 3, md: 4 } }}>
      <Box component="main" sx={{ p: { xs: 2, md: 3 }, flexGrow: 1 }}>
        <Paper
          sx={{
            p: 3,
            mb: 3,
            backgroundColor: "mint.main",
            borderRadius: "12px",
          }}
        >
          {loading ? (
            <>
              <Skeleton variant="text" width="40%" height={48} sx={{ mb: 1 }} />
              <Skeleton variant="text" width="70%" />
            </>
          ) : (
            <>
              <Typography
                variant="h4"
                component="h1"
                gutterBottom
                p={1}
                sx={{ color: "primary.main", fontWeight: "bold" }}
              >
                {companyId ? "Edit Company Profile" : "Create Company Profile"}
              </Typography>
              <Typography variant="body1" color="text.primary">
                {companyId
                  ? "Update your company's details. This information will be visible to candidates."
                  : "Provide your company's details to get started."}
              </Typography>
            </>
          )}
        </Paper>

        <Paper
          component="form"
          onSubmit={handleSubmit}
          sx={{
            backgroundColor: "mint.main",
            borderRadius: "12px",
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
            p: { xs: 2, md: 4 },
          }}
        >
          <CardContent>
            {loading ? (
              <FormSkeleton />
            ) : (
              <>
                <CompanyDetailsFields
                  data={companyData}
                  handleInputChange={handleInputChange}
                  logoPreviewUrl={logoPreviewUrl}
                  handleFileChange={handleFileChange}
                />
                <CompanyDescription
                  data={companyData}
                  handleInputChange={handleInputChange}
                />
                <ContactInfoFields
                  data={companyData}
                  handleInputChange={handleInputChange}
                />

                <Box
                  sx={{
                    mt: 4,
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: 2,
                  }}
                >
                  <Button
                    type="submit"
                    variant="contained"
                    startIcon={<Save />}
                    size="large"
                    disabled={loading}
                  >
                    {loading ? "Saving..." : "Save Profile"}
                  </Button>
                </Box>
              </>
            )}
          </CardContent>
        </Paper>
      </Box>
      </Container>

    </Layout>
  );
};

export default CompanyProfile;